'use client'
import Link from 'next/link'
import { usePathname, useSearchParams } from 'next/navigation'

const STEPS = ['Sản phẩm', 'Đặt hàng', 'Thanh toán', 'Nhận thưởng'] as const

function getCurrentIndex(pathname: string) {
  if (pathname.startsWith('/thanh-toan-thanh-cong')) return 3
  if (pathname.startsWith('/thanh-toan')) return 2
  if (pathname.startsWith('/dat-hang')) return 1
  if (pathname.startsWith('/san-pham')) return 0
  return -1
}

function buildQuery(params: Record<string, string | null | undefined>) {
  const cleaned: Record<string, string> = {}
  for (const [k, v] of Object.entries(params)) {
    if (v) cleaned[k] = v
  }
  return new URLSearchParams(cleaned).toString()
}

export default function PurchaseSteps() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const currentIndex = getCurrentIndex(pathname)

  if (currentIndex === -1) return null

  const productId = searchParams.get('product_id')
  const variantId = searchParams.get('variant_id')
  const partnerId = searchParams.get('partner_id')
  const quantity = searchParams.get('quantity')
  const orderId = searchParams.get('order_id')

  const productQuery = buildQuery({
    product_id: productId,
    variant_id: variantId,
    partner_id: partnerId,
    quantity,
  })

  const isPastPayment = currentIndex >= 2
  const hrefs: (string | null)[] = [
    !isPastPayment && productId ? `/san-pham?${productQuery}` : null,
    productId ? `/dat-hang?${productQuery}` : null,
    orderId
      ? `/thanh-toan?${buildQuery({
          order_id: orderId,
          product_id: productId,
          variant_id: variantId,
          partner_id: partnerId,
          quantity,
        })}`
      : null,
    null,
  ]

  return (
    <div className="sticky top-16 z-40 bg-white border-b border-gray-100 h-12 flex items-center">
      <div className="max-w-7xl w-full mx-auto px-4">
        <nav className="flex items-center gap-2 text-sm font-medium">
          {STEPS.map((label, i) => {
            const isActive = i === currentIndex
            const isPast = i < currentIndex
            const href = hrefs[i]

            const content = isActive ? (
              <span className="font-bold text-transparent bg-clip-text bg-linear-to-r from-violet-600 to-blue-600">
                {label}
              </span>
            ) : isPast && href ? (
              <Link href={href} className="text-gray-500 hover:text-violet-600 transition-colors">
                {label}
              </Link>
            ) : (
              <span className="text-gray-400">{label}</span>
            )

            return (
              <span key={label} className="flex items-center gap-2">
                {i > 0 && <span className="text-gray-300">›</span>}
                {content}
              </span>
            )
          })}
        </nav>
      </div>
    </div>
  )
}
